import { createContext } from "react";
import { IStylesType } from "./types/styles.type";

export const StylesContext = createContext({
  styles: {} as IStylesType,
  generateStyles: (modifications: any) => {},
});